import { ACTION_TYPES } from '../../utils/Constants';

const AppointmentReducer = (
    state = {
        subCategoryList: {},
        educatorList: {},
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.STUDENT.GET_SUBCATEGORY_LIST:
            state = {
                ...state,
                subCategoryList: action.payload,
            };
            break;
        case ACTION_TYPES.STUDENT.GET_EDUCATOR_LIST:
            state = {
                ...state,
                educatorList: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default AppointmentReducer;
